/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single payment history entry for a contract
 * @export
 * @interface PaymentScheduleHistoryItemDto
 */
export interface PaymentScheduleHistoryItemDto {
    /**
     * Unique identifier of the payment schedule
     * @type {string}
     * @memberof PaymentScheduleHistoryItemDto
     */
    id: string;
    /**
     * Payment number in the schedule sequence
     * @type {number}
     * @memberof PaymentScheduleHistoryItemDto
     */
    paymentNumber: number;
    /**
     * Due date of the payment
     * @type {Date}
     * @memberof PaymentScheduleHistoryItemDto
     */
    dueDate: Date;
    /**
     * Payment amount
     * @type {number}
     * @memberof PaymentScheduleHistoryItemDto
     */
    amount: number;
    /**
     * Current status of the payment
     * @type {string}
     * @memberof PaymentScheduleHistoryItemDto
     */
    status: string;
    /**
     * Hex color code for the status badge
     * @type {string}
     * @memberof PaymentScheduleHistoryItemDto
     */
    statusColor?: string | null;
    /**
     * Date when the withdrawal was made
     * @type {Date}
     * @memberof PaymentScheduleHistoryItemDto
     */
    withdrawalDate?: Date | null;
    /**
     * Direct debit key
     * @type {string}
     * @memberof PaymentScheduleHistoryItemDto
     */
    directDebitKey?: string | null;
}

/**
 * Check if a given object implements the PaymentScheduleHistoryItemDto interface.
 */
export function instanceOfPaymentScheduleHistoryItemDto(value: object): value is PaymentScheduleHistoryItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('paymentNumber' in value) || value['paymentNumber'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PaymentScheduleHistoryItemDtoFromJSON(json: any): PaymentScheduleHistoryItemDto {
    return PaymentScheduleHistoryItemDtoFromJSONTyped(json, false);
}

export function PaymentScheduleHistoryItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentScheduleHistoryItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'paymentNumber': json['paymentNumber'],
        'dueDate': (new Date(json['dueDate'])),
        'amount': json['amount'],
        'status': json['status'],
        'statusColor': json['statusColor'] == null ? undefined : json['statusColor'],
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'directDebitKey': json['directDebitKey'] == null ? undefined : json['directDebitKey'],
    };
}

export function PaymentScheduleHistoryItemDtoToJSON(json: any): PaymentScheduleHistoryItemDto {
    return PaymentScheduleHistoryItemDtoToJSONTyped(json, false);
}

export function PaymentScheduleHistoryItemDtoToJSONTyped(value?: PaymentScheduleHistoryItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paymentNumber': value['paymentNumber'],
        'dueDate': ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'status': value['status'],
        'statusColor': value['statusColor'],
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate'] as any).toISOString()),
        'directDebitKey': value['directDebitKey'],
    };
}

